import {CustomerSchema} from '@/models/customer_schema';

export type CustomerState = {
  customers: CustomerSchema[],
  selected: CustomerSchema
};

export type CustomerContext = {
  state: CustomerState;
  dispatch: (action: CustomerActions, payload?: any) => any;
  commit: (mutation: CustomerMutations, payload: any) => any;
};

export enum CustomerMutations {
  SetCustomer = "setCustomer",
  SetSelected = "setSelected"
}

export enum CustomerActions {
  AddAllCustomers = "addAllCustomers",
  EditCustomer = "editCustomer",
  AddCustomer = "addCustomer",
  FetchSingleCustomer ='fetchSingleCustomer',
  DeleteCustomer = "deleteCustomer"
}

export enum CustomerGetters {
  GetAllCustomers = "getAllCustomers",
  GetSelected = "getSelected"
}
